import { OverlayData, OverlayOpenCallback } from '../types';

interface ListenerCallbackOpenParams {
  type: 'open';
  data: OverlayData;
}

interface ListenerCallbackCloseParams {
  type: 'close';
  data: Pick<OverlayData, 'id'>;
}

interface ListenerCallbackCloseAllParams {
  type: 'closeAll';
}

export type ListenerCallbackParams =
  | ListenerCallbackOpenParams
  | ListenerCallbackCloseParams
  | ListenerCallbackCloseAllParams;

interface Listener {
  (params: ListenerCallbackParams): void;
}

class OverlayEventContext {
  private _listeners: Listener[] = [];

  public constructor() {}

  public addEventListener = (listener: Listener) => {
    this._listeners.push(listener);
  };

  public removeEventListener = (listener: Listener) => {
    const index = this._listeners.indexOf(listener);
    if (index >= 0) {
      this._listeners.splice(index, 1);
    }
  };

  public notifyOpen = (id: string, callback: OverlayOpenCallback) => {
    this._listeners.forEach((listener) =>
      listener({
        type: 'open',
        data: { id, callback },
      }),
    );
  };

  public notifyClose = (id: string) => {
    this._listeners.forEach((listener) =>
      listener({
        type: 'close',
        data: { id },
      }),
    );
  };

  public notifyCloseAll = () => {
    this._listeners.forEach((listener) =>
      listener({
        type: 'closeAll',
      }),
    );
  };
}

const overlayEventContext = new OverlayEventContext();

export default overlayEventContext;
